import { Component, Input } from '@angular/core';
import { includedExpression, excludedExpression } from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-breakfast-icon',
  templateUrl: './breakfast-icon.component.html',
  styleUrl: './breakfast-icon.component.scss',
  standalone: false
})
export class BreakfastIconComponent {
  @Input() room: any;

  hasBreakfast(description: string, roomDescription: string, roomGeneralPolicy: string): boolean {
    // Priority 1: Rate Information
    if (description.match(includedExpression)) {
      // If rate has inclusion, check if rate also has exclusion
      if (description.match(excludedExpression)) {
        return false; // Rate has both inclusion and exclusion - don't show icon
      }
      return true; // Rate has inclusion but no exclusion - show icon
    }

    // Priority 2: Room Information
    if (roomDescription?.match(includedExpression)) {
      // If room has inclusion, check if room also has exclusion
      if (roomDescription.match(excludedExpression)) {
        return false; // Room has both inclusion and exclusion - don't show icon
      }
      return true; // Room has inclusion but no exclusion - show icon
    }

    // Priority 3: General Policy (filtered for pricing policy)
    if (roomGeneralPolicy?.match(includedExpression)) {
      // This function call is for malmaison only
      if (this.isPricingPolicy(roomGeneralPolicy)) {
        return false;
      }

      // For actual inclusions, exclusions from any source override inclusion
      if (
        description.match(excludedExpression) ||
        roomDescription?.match(excludedExpression) ||
        roomGeneralPolicy.match(excludedExpression)
      ) {
        return false;
      }
      return true;
    }

    return false;
  }

  private isPricingPolicy(text: string): boolean {
    const pricingPatterns = [
      /breakfast is complimentary for \d+-\d+yr olds/i,
      /breakfast.*\d+pct.*price/i,
      /full price for \d+yrs and over/i,
      /meal plans.*breakfast/i,
      /continental bfast.*continental breakfast/i
    ];

    return pricingPatterns.some((pattern) => text.match(pattern));
  }
}
